<template>
  <div
    class="wrapper"
  >
    <div class="field" @click="treeShow()">{{ name_ }}</div>

    <Modal
      :show="show"
      :fixed="true"
      :loading="loading"
      :acceptButtonText="$t( 'Select' )"

      @accept="select()"
      @close="treeHide()"
      @cancel="treeHide()"
      @hided=""
    >
      <Tree
        v-if="$options.tree && show"

        :label="$t( 'SelectClass' )"
        class="tree"
        :data="tree"
        :CSSnames="nodeCSSnames"
        :selectedId="id"
        :filter="filter"

        @filter="treeFilter( $event )"
        @selected="treeSelect( $event )"
        @accept="select( $event )"
      />

      <Tooltip
        type="error"
        class="tipError"
        orientation="bottom"
        anglePosition="start"
        :show="nothingToSelect"

        @close="nothingToSelect = false"
      >
        {{ $t( "SpecifyClass" ) }}
      </Tooltip>

    </Modal>
</div>
</template>

<script>
import Tree from "@/components/tree/Tree";
import Modal from "@/components/Modal";
import Tooltip from "@/components/Tooltip";
import utils from "../utils";

/**
 *
 * @param itemsToSort - is an object { id: ..., ... }
 * @param itemsAll    - is an object { id: { name: ..., children: { ... } }, ... }
 */
const treeSortBack = ( itemsToSort, itemsAll ) => {
  return Object.fromEntries(
    Object.entries( itemsToSort )
      .sort(
        ( a, b ) => {
          const ao = itemsAll[ a[0] ];
          const bo = itemsAll[ b[0] ];

          let c = utils.objIsEmpty( ao.children ) - utils.objIsEmpty( bo.children );
          if ( c != 0 ) return c;

          c = ao.name.localeCompare( bo.name )
          if ( c != 0 ) return c;

          return a[0].localeCompare( b[0] );
        }
      )
  );
};

/**
 * find node in tree
 *
 * @param node  - starting node
 * @param id    - id to find
 * @param path
 */
const nodeFind = ( node, id, path ) => {
  if ( node ) {
    if ( node.id === id ) return { node, path }

    if ( node.children ) {
      if ( path ) path.push( node );
      else path = [ node ];

      for ( let i = 0; i < node.children.length; i++ ) {
        const child = node.children[ i ];
        const t = nodeFind( child, id, path );
        if ( t ) return t;
      }

      path.pop();
    }
  }
}

//noinspection ES6MissingAwait
export default {
  name: "DVclassSelect",

  components: {
    Tree,
    Modal,
    Tooltip
  },

  tree: null,

  i18n: {
    messages: {
      ru: {
        Select:              "Выбрать",
        SpecifyClass:        "Укажите класс, который требуется выбрать",
        SelectClass:         "Выберите класс",
        ErrorGetClassesList: "Ошибка получения списка классов",
      },

      en: {
        Select:              "Select",
        SpecifyClass:        "Specify the class to be selected",
        SelectClass:         "Select class",
        ErrorGetClassesList: "Classes list request error",
      },

      kz: {
        Select:              "Таңдау",
        SpecifyClass:        "Таңдалатын сыныпты көрсетіңіз",
        SelectClass:         "Сынып таңдаңыз",
        ErrorGetClassesList: "Сыныптар тізімін алу қатесі",
      }
    }
  },

  props: {
    params: {
      type: Object,
      default: () => ( {} )
    },
    includeStdClasses: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      show: false,
      loading: false,

      treeSelected: null,
      nothingToSelect: false,

      tree: { id: null, name: null, children: [] },

      filter: "",
    };
  },

  async mounted() {
  },

  methods: {
    nodeCSSnames( node ) {
      let names = "";

      if ( node ) {
        if ( node.marked ) names += " marked";
        if ( node.archive ) names += " archive";
      }

      return names;
    },

    treeFilter( value ) {
      this.filter = value ? value : "";

      //noinspection ES6MissingAwait
      this.treeBuild();
    },

    async treeBuild() {
      this.loading = true;

      if ( !this.$options.tree ) {
        try {
          const ans = await this.$options.api.post.json(
            "/schema",
            {
              ...this.queryStd,
              ...this.params
            }
          );

          //tree converting
          //const tree = ans.items; //if no sort is required

          //sort root
          const tree = treeSortBack( ans.items, ans.items );
          //sort children of all items
          for ( const id in ans.items ) {
            if ( ans.items.hasOwnProperty( id ) ) {
              const item = ans.items[ id ];
              item.children = treeSortBack( item.children, ans.items );
            }
          }

          //remove standard classes which ids are not start with something from attrsStdInclude
          if ( !this.includeStdClasses ) {
            for ( const id in tree ) {
              if (
                tree.hasOwnProperty( id ) &&
                id.includes( "http://www.w3.org/" ) &&
                ( !this.$options.attrsStdInclude || this.$options.attrsStdInclude.findIndex( i => id.includes( i ) ) == -1 )
              ) delete tree[ id ];
            }
          }

          let allIds = [];
          let childrenIds = [];
          for ( const id in tree ) {
            if ( tree.hasOwnProperty( id ) ) {
              const i = tree[ id ];
              const childrenI = Object.keys( i.children );

              allIds.push( id );

              if ( childrenI.length ) {
                childrenIds = childrenIds.concat( childrenI );
                i.children = childrenI.reduce( ( a, id ) => { if ( id in tree ) a.push( tree[ id ] ); return a; }, [] );
              }
              else delete i.children;
            }
          }

          const treeNew = {
            id: null,
            name: null,
            children: allIds.filter( id => !childrenIds.includes( id ) ).map( id => tree[ id ] )
          };

          this.$options.tree = treeNew;
        }
        catch ( e ) {
  		    console.error( "CLASSES REQUEST ERROR: request items is failed with " + e.message, e.stack );
          this.$root.$emit( "notify", { header: this.$t( "ErrorGetClassesList" ), message: e.message, type: "error" } );
        }
      }

      const tree = this.$options.tree ? JSON.parse( JSON.stringify( this.$options.tree ) ) : { id: null, name: null, children: [] };

      let treeNew;

      if ( this.filter ) {
        const cache = {};
        const filteredBranches = ( childrenOrItem, name ) => {
          if ( childrenOrItem.children ) childrenOrItem = childrenOrItem.children;

          return childrenOrItem.reduce(
            ( r, i ) => {
              let children = i.children || [];
              let o;
              if ( cache[ i.id ] ) o = cache[ i.id ];
              else {
                o = { ...i, children: [] };
                cache[ i.id ] = o;
              }

              children = filteredBranches( children, name );
              if ( children.length ) o.children = children;

              const marked = o.name.toLowerCase().includes( name );
              if ( children.length || marked ) {
                if ( marked ) o.marked = true;
                if ( o.children && o.children.length ) o.opened = true;
                r.push( o );
              }

              return r;
            },
            []
          );
        }

        treeNew = { ...tree, children: filteredBranches( tree, this.filter.toLowerCase() ) };
      }
      else treeNew = tree;

/*
      //sort children
      const walk = ( node, h ) => {
      };

console.log( treeNew );
*/
      if ( this.id ) {
        const data = nodeFind( tree, this.id );
        if ( data ) {
            for ( const p of data.path ) p.opened = true;
        }
      }

      this.loading = false

      this.tree = treeNew;
    },

    async treeShow() {
      this.treeSelected = null;

      //noinspection ES6MissingAwait
      this.treeBuild();

      await this.$nextTick();
      this.show = true;
    },

    treeHide() {
      this.treeSelected = null;
      this.show = false;
    },

    treeSelect( node ) {
      this.treeSelected = node;
    },

    select( node ) {
      if ( node ) {
        this.treeSelected = node;
        this.show = false;
        this.$emit( "selected", this.treeSelected );

        return;
      }

      if ( this.treeSelected ) {
        this.show = false;
        this.$emit( "selected", this.treeSelected );
      }
      else {
        if ( this.id ) this.show = false;
        else this.nothingToSelect = true;
      }
    }
  },
  computed: {
    name_() {
      return this.name ? this.name : this.id;
    }
  },
  watch: {
    params( v, ov ) {
      if ( JSON.stringify( v ) != JSON.stringify( ov ) ) this.$options.tree = null;
    }
  }
}
</script>

<style scoped>
  .wrapper {
    display: inline-block;
  }

  .tree::v-deep .archive {
    color: #8E8E8E;
  }

  .field {
    display: inline-block;
    cursor: pointer;
  }

  .tipError {
    width: 14em;
    position: absolute;
    top: 3em;
  }
</style>
